import React, { useMemo } from 'react';

import { User } from '../../auth/login/store';
import styles from '../HomeWrapper.module.scss';
import { ProfilePicture } from '../../shared/picture/ProfilePicture';
import Logo from '../../../assets/logos/Ark51_HORIWHITE&GRAD.png';
import { CustomTooltip, OverflowTooltip } from '../../shared/tooltip';

interface MinifiedProfileProps {
    user: User | null;
    openProfile: () => void;
}

export const MinifiedProfile: React.FC<MinifiedProfileProps> = ({ user, openProfile }) => {
    const { profilePicture, initials, name, clientName } = useMemo(() => {
        if (!user) {
            return { profilePicture: undefined, initials: undefined, name: '', clientName: '' };
        }
        const { profilePicture, forenames, surname, clientName, username } = user;
        const name = (forenames && surname) ? `${forenames} ${surname}` : username;
        return { profilePicture, initials: `${forenames.charAt(0)}${surname.charAt(0)}`, name, clientName };
    }, [user]);

    return (
        <CustomTooltip overlayText='Open My Profile' placement='bottom'>
            <button className={styles.minifiedProfile} onClick={openProfile}>
                <div className={styles.profilePicture}>
                    <ProfilePicture profilePicture={profilePicture} initials={initials} userIconSize={120} initialsFontSize={40} />
                </div>
                <div className={styles.profileDetails}>
                    <div className={styles.logoWrapper} data-testid='minified-profile-logo-wrapper'>
                        <img className={styles.logo} src={Logo} />
                    </div>
                    <div className={styles.usernameWrapper}>
                        <OverflowTooltip className={styles.username} overlayText={name} cursor='pointer' />
                    </div>
                    <div className={styles.clientWrapper}>
                        <OverflowTooltip className={styles.client} overlayText={clientName} cursor='pointer' />
                    </div>
                </div>
            </button>
        </CustomTooltip>
    );
};
